import React, { type FunctionComponent } from 'react'
import { NavSelect } from 'gin-and-tonic/containers/nav/components/NavSelect'
import { NavSeparator } from 'gin-and-tonic/containers/nav/components/NavSeparator'

export const RetailerNavHeaderContent: FunctionComponent = () => (
  <React.Fragment>
    <NavSelect />
    <NavSeparator />
  </React.Fragment>
)
